import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CaregiverLogsComponent } from './caregiver-logs.component';

const routes: Routes = [{path:'', component : CaregiverLogsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CaregiverLogsRoutingModule { }
